import { motion } from "framer-motion";
import { Mandala } from "./Mandala";
import { weddingConfig } from "../config/weddingConfig";

const EASE = [0.22, 1, 0.36, 1];

export const ClosingFooter = () => {
  const { couple, footer } = weddingConfig;

  return (
    <footer
      data-testid="footer-section"
      className="relative overflow-hidden bg-emerald-deep px-6 py-24 text-center"
    >
      <Mandala className="pointer-events-none absolute left-1/2 top-1/2 h-[110vmin] w-[110vmin] -translate-x-1/2 -translate-y-1/2 text-gold/[0.08]" />

      <motion.div
        initial={{ opacity: 0, y: 26 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative mx-auto flex max-w-xl flex-col items-center"
      >
        {/* gold motif */}
        <div className="flex items-center gap-3" aria-hidden="true">
          <span className="h-px w-12 bg-gold/50" />
          <span className="h-2 w-2 rotate-45 border border-gold" />
          <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
          <span className="h-2 w-2 rotate-45 border border-gold" />
          <span className="h-px w-12 bg-gold/50" />
        </div>

        <p className="mt-10 font-serif text-xl italic leading-relaxed text-cream/90 sm:text-2xl">
          {footer.closingLine}
        </p>

        <p className="mt-8 font-serif text-3xl font-medium text-gold-bright sm:text-4xl">
          {couple.firstName}{" "}
          <span className="font-script text-2xl sm:text-3xl">&</span>{" "}
          {couple.secondName}
        </p>

        <p className="mt-12 font-sans text-[10px] uppercase tracking-[0.35em] text-cream/40">
          {footer.note}
        </p>
      </motion.div>
    </footer>
  );
};
